import { IonLabel, IonPopover, IonRouterLink } from '@ionic/react';
import React, { useCallback, useMemo } from 'react';

import { Icon } from '@/components/memo';
import { generateRandomString } from '@/utils/helpers/generateRandomString';
import { MenuItem } from '@/utils/types';

import './Menu.css';

interface MenuProps {
  triggerIcon?: string;
  triggerClassName?: string;
  triggerContent?: React.ReactNode;
  items: MenuItem[];
  side?: 'top' | 'bottom' | 'left' | 'right' | 'start' | 'end';
  alignment?: 'start' | 'center' | 'end';
  className?: string;
}

const Menu: React.FC<MenuProps> = ({
  triggerIcon,
  triggerClassName = '',
  triggerContent,
  items,
  side = 'bottom',
  alignment = 'end',
  className = ''
}) => {
  const triggerId = useMemo(() => generateRandomString(), []);
  const popoverId = useMemo(() => generateRandomString(), []);

  const onItemClick = useCallback((onClick: () => void) => {
    onClick();
  }, []);

  return (
    <>
      <div
        className={`menu__trigger ${triggerClassName} ${triggerId}`}
        id={triggerId}
      >
        {triggerContent ||
          (triggerIcon && (
            <Icon icon={triggerIcon} className="menu__trigger-icon" />
          ))}
      </div>
      <IonPopover
        id={popoverId}
        trigger={triggerId}
        triggerAction="click"
        className={`menu ${className}`}
        reference="trigger"
        side={side}
        alignment={alignment}
        arrow={false}
        dismissOnSelect={true}
      >
        <div className="menu__content" role="menu">
          {items.map((item, index) => (
            <IonRouterLink
              key={index}
              className="menu__item"
              onClick={() => onItemClick(item.onClick)}
              role="menuitem"
              tabIndex={0}
            >
              <div className="menu__item-content">
                <Icon icon={item.icon} />
                <IonLabel>{item.label}</IonLabel>
              </div>
            </IonRouterLink>
          ))}
        </div>
      </IonPopover>
    </>
  );
};

export default Menu;
